import React, { useContext, useState } from 'react';
import { Button, message } from 'antd';
import { CreditCardOutlined } from '@ant-design/icons';
import { isExternallyBilled } from '@leedpulse-monorepo/enums';
import AuthenticationContext from '../../contexts/auth/AuthenticationContext';
import CompanyContext from '../../contexts/company/CompanyContext';
import PageScaffold from '../../components/PageScaffold';
import { createBillingPortalSession } from '../../../domain/use_cases/stripe/createBillingPortalSession';
import CompanyPageHeader from './CompanyPageHeader';
import { getCompanyTabPath } from './useCompanyTabs';
import '../settings/SettingsPage.css';

export const COMPANY_BILLING_PAGE_PATH = getCompanyTabPath('billing');
export const COMPANY_BILLING_PAGE_TITLE = 'Facturation';

const CompanyBillingPage: React.FC = () => {
  const { authentication } = useContext(AuthenticationContext);
  const { activeCompany } = useContext(CompanyContext);
  const [billingLoading, setBillingLoading] = useState(false);

  /**
   * Open the Stripe billing portal in a new tab so the user
   * can manage their subscription, payment methods, invoices, etc.
   */
  const handleOpenBillingPortal = async () => {
    if (!activeCompany || !authentication) {
      message.error('Aucune compagnie active ou utilisateur non authentifié');
      return;
    }
    if (!activeCompany.api_key) {
      message.error('Clé API de la compagnie manquante');
      return;
    }

    setBillingLoading(true);
    try {
      const response = await createBillingPortalSession(
        {
          company_id: activeCompany.id,
          company_api_key: activeCompany.api_key,
          return_url: window.location.href,
        },
        authentication,
      );
      window.open(response.url, '_blank');
    } catch (error) {
      console.error('Billing portal error:', error);
      message.error(
        (error as Error).message || "Erreur lors de l'ouverture de la facturation",
      );
    } finally {
      setBillingLoading(false);
    }
  };

  return (
    <PageScaffold
      header={<CompanyPageHeader />}
      title={COMPANY_BILLING_PAGE_TITLE}
      subtitle="Gérez votre abonnement, vos moyens de paiement et consultez vos factures."
    >
      <div className="settings-page__form">
        <div className="settings-page__form-actions">
          {isExternallyBilled(activeCompany?.partner_system, activeCompany?.id_stripe) ? (
            <p>Pour toute questions ou demandes relatives à la facturation, merci de contacter directement votre interlocuteur Modelo.</p>
          ) : (
            <Button
              type="primary"
              icon={<CreditCardOutlined />}
              className="settings-page__save-button"
              onClick={handleOpenBillingPortal}
              loading={billingLoading}
              disabled={billingLoading}
            >
              Gérer mon abonnement
            </Button>
          )}
        </div>
      </div>
    </PageScaffold>
  );
};

export default CompanyBillingPage;
